import * as types from '@store/types'
import request from '@queries'
import TransactionsQuery from '@queries/Transactions'
import GiftCardQuery from '@queries/GiftCard'

const state = {
  transactions: [],
  pagination: { }
}

const getters = {
  [types.TRANSACTIONS]: ({ transactions }) => [...transactions],
  [types.TRANSACTIONS_PAGINATION]: ({ pagination }) => ({ ...pagination })
}

const mutations = {
  [types.TRANSACTIONS]: (state, { data, ...pagination }) => {
    state.transactions = [...data]
    state.pagination = { ...pagination }
  },
  [types.TRANSACTIONS_PAGINATION]: (state, { data, ...pagination }) => {
    state.transactions = [...state.transactions, ...data]
    state.pagination = { ...pagination }
  }
}

const actions = {
  [types.TRANSACTIONS]: async ({ commit }, variables) => {
    const response = await request(TransactionsQuery, { ...variables })
    commit(types.TRANSACTIONS, response.data.data.transactions || { })
  },
  [types.TRANSACTIONS_PAGINATION]: async ({ commit }, variables) => {
    const response = await request(TransactionsQuery, { ...variables })
    commit(types.TRANSACTIONS_PAGINATION, response.data.data.transactions || { })
  },
  [types.GET_GIFT_CARD]: async ({ commit }, payload) => {
    const response = await request(GiftCardQuery, { ...payload })
    return response.data.data.giftCard
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/transaction.js